import { useEffect, useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import Select from "react-select";
import { toast, ToastContainer } from "react-toastify";
import creditRequestApi from "../../../../../api/creditRequestApi";
import creditTransferApi from "../../../../../api/creditTransferApi";
import usersApi from "../../../../../api/userApi";

const TransferFrymesModal = ({ show, onClose, onSuccess }) => {
  const user = JSON.parse(localStorage.getItem("user"));

  const [fromEmail, setFromEmail] = useState("");
  const [toEmail, setToEmail] = useState("");
  const [credits, setCredits] = useState("");
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userCredits, setUserCredits] = useState(null);
  const [creditLoading, setCreditLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (show) {
      const email = user?.userEmail || "";
      setFromEmail(email);
      fetchUsers();
      if (email) {
        fetchUserCredits(email);
      }
      setCredits("");
      setToEmail("");
      setErrorMessage("");
    }
  }, [show]);

  const fetchUserCredits = async (email) => {
    try {
      setCreditLoading(true);
      const response = await creditRequestApi.getUserCredits(email);
      const creds = response.data;
      setUserCredits(creds);

      const paidBalance = creds?.balanceCredit || 0;
      
      if (paidBalance <= 0) {
        setErrorMessage("Only free frymes, no paid credits. You are not eligible for transfer because these are free frymes you got from signbook so you cannot.");
      }
    } catch (error) {
      console.error("Error fetching user credits", error);
    } finally {
      setCreditLoading(false);
    }
  };
  const userOptions = users
    .filter((u) => u.userEmail !== fromEmail)
    .map((u) => ({
      value: u.userEmail,
      label: `${u.userName} (${u.userEmail})`,
    }));

  const fetchUsers = async () => {
    try {
      const response = await usersApi.getAllUsers();
      setUsers(response.data || []);
      console.log(response.data);
    } catch (error) {
      console.error("Failed to load users", error);
    }
  };

  const handleTransfer = async () => {
    try {
      setLoading(true);

      await creditTransferApi.transferCredits({
        transferType: "USER",
        fromEmail,
        toEmail,
        credits: Number(credits),
      });

      toast.success("Frymes transferred successfully!");

      setCredits("");
      setToEmail("");

      if (onSuccess) {
        onSuccess();
      }

      setTimeout(() => {
        onClose();
      }, 1500);
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to transfer frymes",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal show={show} onHide={onClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Transfer Frymes</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>From Email</Form.Label>
            <Form.Control value={fromEmail} disabled />
            {creditLoading && <div className="mt-2 text-muted"><Spinner size="sm" animation="border" /> Fetching credits...</div>}
          </Form.Group>

          {userCredits && (
            <div className="mb-3">
              <p style={{ fontSize: "14px" }}>
                <strong>Free frymes:</strong> {userCredits?.freeFrymesBalance || 0}
                &nbsp;||&nbsp;
                <strong>Used Free frymes:</strong> {userCredits?.usedFreeToday || 0}
                &nbsp;||&nbsp;
                <strong>Total paid frymes:</strong> {userCredits?.creditBought || 0}
                &nbsp;||&nbsp;
                <strong>Balance paid frymes:</strong> {userCredits?.balanceCredit || 0}
                &nbsp;||&nbsp;
                <strong>Used frymes:</strong> {userCredits?.usedCredit || 0}
              </p>
              {errorMessage && <p className="text-danger" style={{ fontSize: "14px", fontWeight: "bold" }}>{errorMessage}</p>}
            </div>
          )}

          <Form.Group className="mb-3">
            <Form.Label>Transfer To</Form.Label>

            <Select
              options={userOptions}
              value={userOptions.find((o) => o.value === toEmail)}
              onChange={(selected) => setToEmail(selected?.value || "")}
              placeholder="Search user..."
              isClearable
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Frymes to Transfer</Form.Label>
            <Form.Control
              type="number"
              min="1"
              value={credits}
              onChange={(e) => setCredits(e.target.value)}
              disabled={!!errorMessage || creditLoading}
            />
            {!errorMessage && userCredits && (
               <Form.Text className="text-success">
                 You can transfer up to {userCredits?.balanceCredit || 0} frymes.
               </Form.Text>
            )}
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>

          <Button
            variant="success"
            onClick={handleTransfer}
            disabled={!toEmail || !credits || loading || !!errorMessage || Number(credits) > (userCredits?.balanceCredit || 0)}
          >
            {loading ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Transferring...
              </>
            ) : (
              "Transfer"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
      />
    </>
  );
};

export default TransferFrymesModal;
